import React from "react";

import ProductPage from "../../../components/ProductPage";

import hero from "../../../img/glasses-in-shop.jpg";
import individualIcon from "../../../img/individual.svg";
import choicesIcon from "../../../img/choices.svg";
import experienceIcon from "../../../img/experience.svg";
import converseLogo from "../../../img/converse-eyewear-logo-white.png";
import bettyBarclayLogo from "../../../img/bettybarclay_white.png";
import crocsLogo from "../../../img/crocs-white.png";
import horsefeathersLogo from "../../../img/horsefeathers-white.png";
import raybanLogo from "../../../img/rayban-white.png";
import tomtailorLogo from "../../../img/tomtailor-white.png";

const Bryle = () => (
  <ProductPage
    title="Brýle"
    subtitle="dioptrické i sluneční"
    description="Brýle, sluneční brýle a jejich značky, které jsou k dostání v Optice Volyně"
    keywords="Optika, Optometrie, Volyně, Brýle, Sluneční brýle"
    hero={hero}
    heroAlt="foto brýlí v prodejně"
    boxes={[
      {
        icon: individualIcon,
        iconAlt: "ikona individuality",
        heading: "Individuální přístup",
        text: "Uvědomujeme si, že každý je výjimečný a proto ke všem zákazníkům přistupujeme individuálně. Snažíme se naslouchat potřebám lidí a společně s nimi vybrat to, co jim bude vyhovovat ze všeho nejvíc.",
      },
      {
        icon: choicesIcon,
        iconAlt: "ikona vyberu",
        heading: "Široký výběr",
        text: "Nabízíme spoustu dioptrických i slunečních brýlí, mezi kterými jsou zastoupeny i ty nejvýznamnější značky a vybere si tak opravdu každý. Samozřejmostí je možnost si brýle na místě vyzkoušet.",
      },
      {
        icon: experienceIcon,
        iconAlt: "ikona certifikatu",
        heading: "Odbornost",
        text: "Můžete se spolehnout, že o vás bude vždy profesionálně postaráno kvalifikovaným personálem. V oblasti péče o zrak máme mnohaletou praxi a rádi se s vámi o naše zkušenosti podělíme během vaší návštěvy.",
      },
    ]}
    brands={[
      { src: converseLogo, alt: "converse-eyewear-logo" },
      { src: bettyBarclayLogo, alt: "bettybarclay-logo" },
      { src: crocsLogo, alt: "crocs-logo" },
      { src: horsefeathersLogo, alt: "horsefeathers-logo" },
      { src: raybanLogo, alt: "rayban-logo" },
      { src: tomtailorLogo, alt: "tomtailor-logo" },
    ]}
  />
);

export default Bryle;
